<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>User Details</ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
            <ion-button class="hdrBtn" @click="addNewCPO">
              Edit
            </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <UserDetails @user-loaded="setUserDetails" />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
// import TariffDetails from "@/components/admin/TariffDetails.vue";
import UserDetails from "@/components/admin/UserDetails.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonBackButton } from '@ionic/vue';

export default defineComponent({
  name:  'userDetails',
  components: {
    UserDetails, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add,
      selectedUser: null
    }
  },
  methods: {
    setUserDetails(user) {
      this.selectedUser = user;
    },

    navigatePreviousPage() {
      
      this.$router.go(-1)
    },
    
    addNewCPO() {
      localStorage.setItem( "editUserData", JSON.stringify(this.selectedUser));
      localStorage.setItem("isEditingUser", "true");
      this.$router.push("addNewUser"); 
    }
  }
})
</script>